import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { JPMAM_NET_ORDER_BASE_PATH } from '../../../../../../../../../features/vendor/jpmam/net-order/jpmam-net-order-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/net-order/_net-order')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'jpmam-net-order-list',
        label: 'J.P. Morgan',
        to: JPMAM_NET_ORDER_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
